import { AntdListInferencer } from '@refinedev/inferencer/antd'

const ListResources = () => {
  return (
    <AntdListInferencer />
  )
}

export default ListResources